export const getCompanyLogo = (state) => state.login.companyLogoUrl;
export const getIdentityProviders = (state) => state.login.identityProviders;
export const getStandardLoginErrors = (state) => state.login.standardLoginErrors;
export const getSSOLoginErrorMessage = (state) => state.login.ssoLoginErrorMessage;
export const getActiveDialog = (state) => state.login.activeDialog;
export const getAppetizePreferences = (state) => state.loginParams.appetizePreferences;
